module.exports = __webpack_public_path__ + "static/img/finance.39fc4842.png";